export default __webpack_public_path__ + "static/media/dry-cleaning.inline.12ec6f27.svg";